"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SourceCreateProcessor", {
    enumerable: true,
    get: function() {
        return SourceCreateProcessor;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _common = require("@nestjs/common");
const _sourcesservice = require("~/services/sources.service");
const _jobslogservice = require("~/modules/jobs/jobs/jobs-log.service");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let SourceCreateProcessor = class SourceCreateProcessor {
    async job(job) {
        this.debugLog(`job started for ${job.id}`);
        const { context, baseId, source, req, user } = job.data;
        const logBasic = (log)=>{
            this.jobsLogService.sendLog(job, {
                message: log
            });
            this.debugLog(log);
        };
        const { source: createdSource, error } = await this.sourcesService.baseCreate(context, {
            baseId,
            source,
            logger: logBasic,
            req
        });
        if (error) {
            await this.sourcesService.baseDelete(context, {
                sourceId: createdSource.id,
                req: {
                    user: user || req.user || {}
                }
            });
            throw error;
        }
        if (createdSource.isMeta()) {
            delete createdSource.config;
        }
        this.debugLog(`job completed for ${job.id}`);
    }
    constructor(sourcesService, jobsLogService, appHooksService){
        this.sourcesService = sourcesService;
        this.jobsLogService = jobsLogService;
        this.appHooksService = appHooksService;
        this.debugLog = (0, _debug.default)('nc:jobs:source-create');
    }
};
SourceCreateProcessor = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _sourcesservice.SourcesService === "undefined" ? Object : _sourcesservice.SourcesService,
        typeof _jobslogservice.JobsLogService === "undefined" ? Object : _jobslogservice.JobsLogService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], SourceCreateProcessor);
